import { jsonFetch } from "@/lib/helpers";
import { getIcneaPropertiesUrl } from "./api-url.constants";

export interface IcneaPropertyResponse {
  lodging_id: number;
  name: string;
  address: string;
  zip: string;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
}

export const getIcneaProperties = async (userId?: string): Promise<IcneaPropertyResponse[]> => {
  const { data } = await jsonFetch<{ data: IcneaPropertyResponse[] }>(
    getIcneaPropertiesUrl(userId)
  );
  return data;
};
